import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-36cd61c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_avatar = _resolveComponent("el-avatar");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-start box-border max-w-full", {
      'self-end': _ctx.isMe,
      'flex-row-reverse': !_ctx.isMe
    }])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["p-2 rounded border mb-5 text-sm leading-5 max-w-full overflow-hidden sm:max-w-screen-md bg-gray-100", {
      'bg-indigo-200/50': _ctx.isMe
    }])
  }, [!_ctx.isMe ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "markdown-body",
    onMousedown: _cache[0] || (_cache[0] = (...args) => _ctx.stop && _ctx.stop(...args)),
    onMouseup: _cache[1] || (_cache[1] = (...args) => _ctx.start && _ctx.start(...args)),
    innerHTML: _ctx.renderHtml
  }, null, 40, _hoisted_1)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "markdown-body",
    style: {
      "white-space": "pre-wrap"
    },
    onMousedown: _cache[2] || (_cache[2] = (...args) => _ctx.stop && _ctx.stop(...args)),
    onMouseup: _cache[3] || (_cache[3] = (...args) => _ctx.start && _ctx.start(...args))
  }, _toDisplayString(_ctx.str), 33)), !_ctx.isMe && !_ctx.writing ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "text-indigo-400 mt-3",
    onClick: _cache[4] || (_cache[4] = (...args) => _ctx.copyAll && _ctx.copyAll(...args))
  }, " 复制内容 ")) : _createCommentVNode("", true)], 2), _createVNode(_component_el_avatar, {
    shape: "square",
    size: 35,
    class: _normalizeClass(["flex-none", {
      'ml-2': _ctx.isMe,
      'mr-2': !_ctx.isMe
    }]),
    src: _ctx.isMe ? _ctx.userInfo.avatar : 'https://baga-1317914855.cos.ap-chongqing.myqcloud.com/tishiimg/kefu.png?imageView2/1/w/50/h/50'
  }, null, 8, ["class", "src"])], 2);
}